import { jsx } from "@builder.io/qwik/jsx-runtime";
import { component$, useSignal, useComputed$, useTask$, useContextProvider, Slot } from "@builder.io/qwik";
import { accordionContextId } from "./accordion-context.qwik.mjs";
const HAccordionRootImpl = component$((props) => {
  const { multiple, "bind:value": givenValueSig, initialIndex, onChange$, disabled, collapsible = true, animated, itemsMap, ...rest } = props;
  const selectedIndexSig = useSignal(initialIndex ?? -1);
  const triggerRefsArray = useSignal([]);
  const isAnimatedSig = useSignal(animated === true);
  const isMultipleSig = useSignal(multiple || props.behavior === "multi");
  const itemsMapSig = useComputed$(() => {
    return props.itemsMap;
  });
  const context = {
    selectedIndexSig,
    givenValueSig,
    isMultipleSig,
    initialIndex,
    onChange$,
    itemsMapSig,
    triggerRefsArray,
    disabled,
    collapsible,
    isAnimatedSig
  };
  useTask$(({ track }) => {
    context.disabled = track(() => disabled);
  });
  useContextProvider(accordionContextId, context);
  return /* @__PURE__ */ jsx("div", {
    ...rest,
    "data-accordion": true,
    children: /* @__PURE__ */ jsx(Slot, {})
  });
});
export {
  HAccordionRootImpl
};
